import React from 'react'
import Grid from '@mui/material/Grid2';
import { Button } from '@mui/material';
import { IconArrowBarDown } from '@tabler/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { setReservationClientVoucherVisibility, setReservationOverviewVisibility } from 'src/store/reservations/slices/hotels/HotelDetailSlice';
import { useMsal } from '@azure/msal-react';
import { generateClientVoucher} from 'src/store/reservations/slices/ReservationsManagerSlice';
import { CircularProgress } from '@mui/material';

const GenerateVoucher = ({setError}) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { instance, accounts } = useMsal();
    const { isVoucherLoading, isImageLoading } = useSelector((state) => state.reservationsSummaryReducer);

    const handleClick = async () => {
        try {
            dispatch(setReservationOverviewVisibility(false));
            dispatch(setReservationClientVoucherVisibility(true));
            
            const result = await dispatch(generateClientVoucher(instance, accounts, id));
            navigate(`/reservations/${id}/client-voucher/${result.Id}`);

        } catch (error) {
            setError(error);
        }
    };

    const isLoading = isVoucherLoading || isImageLoading;

    return (
        <Grid display="flex" justifyContent="end" alignItems="center">
            <Button
                variant='contained'
                color='success'
                onClick={handleClick}
                disabled={isLoading}
            >
                {isLoading ? (
                    <CircularProgress size={24} color="success" />
                ) : (
                    <>
                        Generate New
                        <IconArrowBarDown style={{ marginLeft: "6px" }} size={18} />
                    </>
                )}
            </Button>
        </Grid>
    )
}

export default GenerateVoucher